import { render } from "./Create75Liquidation1.vue?vue&type=template&id=10b922bc"
import script from "./Create75Liquidation1.vue?vue&type=script&lang=js"
export * from "./Create75Liquidation1.vue?vue&type=script&lang=js"

import "./Create75Liquidation1.vue?vue&type=style&index=0&id=10b922bc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__